import {
  ActivityIcon,
  BookMarkedIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  ChevronsUpDownIcon,
  CopyIcon,
  FileTextIcon,
  LayersIcon,
  LayoutIcon,
  MicroscopeIcon,
  PencilIcon,
  PuzzleIcon,
  RotateCcwIcon,
  RotateCwIcon,
  RouteIcon,
  SearchCodeIcon,
  ServerCogIcon,
  TreePalmIcon,
  XIcon,
  SunIcon,
  MoonIcon,
  WifiOffIcon,
  RabbitIcon,
  TurtleIcon,
  CircleXIcon,
  MinusIcon,
} from '../components/icon'
import { cn } from '../lib/utils'
import { Button } from '../components/button'
import { IconButton } from '../components/icon-button'
import { Emoji } from '../components/emoji'
import { Input } from '../components/input'
import { Text } from '../components/text'
import { Separator } from '../components/separator'
import { Checkbox } from '../components/checkbox'
import { Switch } from '../components/switch'
import {
  Select,
  SelectItem,
  SelectPopup,
  SelectTrigger,
  SelectValue,
} from '../components/select'
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarInset,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubItem,
  SidebarProvider,
  SidebarRail,
  SidebarTrigger,
} from '../components/sidebar'
import {
  SidebarTree,
  SidebarTreeBranch,
  SidebarTreeLeaf,
} from '../components/sidebar-tree'
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '../components/collapsible'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '../components/menu'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '../components/breadcrumb'
import type { StorybookUIConfig } from './storybook-ui'

export const uStorybookUI: StorybookUIConfig = {
  cn,

  tokens: {
    color: {
      border: 'border-border',
      surface: 'bg-surface-2',
    },
  },

  Text,

  icons: {
    X: XIcon,
    Copy: CopyIcon,
    Pencil: PencilIcon,
    RotateCcw: RotateCcwIcon,
    RotateCw: RotateCwIcon,
    ChevronDown: ChevronDownIcon,
    ChevronRight: ChevronRightIcon,
    FileText: FileTextIcon,
    Layers: LayersIcon,
    Layout: LayoutIcon,
    Puzzle: PuzzleIcon,
    BookMarked: BookMarkedIcon,
    ChevronsUpDown: ChevronsUpDownIcon,
    ServerCog: ServerCogIcon,
    Microscope: MicroscopeIcon,
    SearchCode: SearchCodeIcon,
    TreePalm: TreePalmIcon,
    Route: RouteIcon,
    Activity: ActivityIcon,
    Sun: SunIcon,
    Moon: MoonIcon,
    WifiOff: WifiOffIcon,
    Rabbit: RabbitIcon,
    Turtle: TurtleIcon,
    CircleX: CircleXIcon,
    Minus: MinusIcon,
  },

  Sidebar: {
    Provider: SidebarProvider,
    Root: Sidebar,
    Inset: SidebarInset,
    Trigger: SidebarTrigger,
    Content: SidebarContent,
    Header: SidebarHeader,
    Group: SidebarGroup,
    GroupLabel: SidebarGroupLabel,
    GroupContent: SidebarGroupContent,
    Menu: SidebarMenu,
    MenuButton: SidebarMenuButton,
    MenuItem: SidebarMenuItem,
    MenuSub: SidebarMenuSub,
    MenuSubItem: SidebarMenuSubItem,
    Rail: SidebarRail,
    Tree: SidebarTree,
    TreeBranch: SidebarTreeBranch,
    TreeLeaf: SidebarTreeLeaf,
  },

  Collapsible: {
    Root: Collapsible,
    Trigger: CollapsibleTrigger,
    Content: CollapsibleContent,
  },

  DropdownMenu: {
    Root: DropdownMenu,
    Trigger: DropdownMenuTrigger,
    Content: DropdownMenuContent,
    Item: DropdownMenuItem,
    Sub: DropdownMenuSub,
    SubTrigger: DropdownMenuSubTrigger,
    SubContent: DropdownMenuSubContent,
    Group: DropdownMenuGroup,
    Label: DropdownMenuLabel,
    RadioGroup: DropdownMenuRadioGroup,
    RadioItem: DropdownMenuRadioItem,
    Separator: DropdownMenuSeparator,
    Shortcut: DropdownMenuShortcut,
  },

  Breadcrumb: {
    Root: Breadcrumb,
    List: BreadcrumbList,
    Item: BreadcrumbItem,
    Page: BreadcrumbPage,
    Separator: BreadcrumbSeparator,
  },

  Button,
  IconButton,
  Separator,
  Input,
  Checkbox,
  Switch,

  Select: {
    Root: Select,
    Trigger: SelectTrigger,
    Value: SelectValue,
    Popup: SelectPopup,
    Item: SelectItem,
  },

  Emoji,
}
